// extracted by mini-css-extract-plugin
module.exports = {"cc-side-effect-summary":"_1hfzA","cc-side-effect-summary-navbar":"sIK9-","cc-side-effect-summary-btn":"_3x_ov","cc-selected":"_5KMAq","cc-side-effect-summary-wrap":"_1j_2M"};